import { render, staticRenderFns } from "./BmOrders.vue?vue&type=template&id=917edd88&"
import script from "./BmOrders.vue?vue&type=script&lang=js&"
export * from "./BmOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports